import { Row } from 'react-bootstrap';
import CaresTypeSelector from '../CaresTypeSelector';
import CaresTypeRenderer from '../CaresTypeRenderer';
import CaresProgramOptions from './CaresProgramOptions';
import AdditionalInformationField from '../../../fields/AdditionalInformationField';

const CaresSection = ({
  form,
  formData,
  setFormField,
  onShowExceptionModal,
  onCaresTypeChange,
  isSubmitting,
}) => {
  const {
    caresType,
    caresExceptionRequestFlg,
  } = form;

  const hasExistingCaresIncomeData = formData?.currentDiscountPercentage !== null;

  return (
    <>
      <CaresTypeSelector
        caresType={caresType}
        numGrantsApplied={formData?.caresPledgesApplied}
        appliedGrantsTotal={formData?.totalCaresGrantsApplied}
        hasActiveDiscountCurrentProgramYear={formData?.hasActiveDiscountCurrentProgramYear}
        hasExistingCaresIncomeData={hasExistingCaresIncomeData}
        isSubmitting={isSubmitting}
        onShowExceptionModal={onShowExceptionModal}
        onChange={value => onCaresTypeChange(value)}
      />

      <CaresTypeRenderer
        form={form}
        formData={formData}
        setFormField={setFormField}
        hasExistingCaresData={hasExistingCaresIncomeData}
        isSubmitting={isSubmitting}
      />

      {caresType && !caresExceptionRequestFlg && (
        <>
          <hr />
          <CaresProgramOptions
            tpaFlg={form?.tpaFlg}
            onTpaFlgChange={value => {
              setFormField('tpaFlg', value);
              setFormField('tpaMonths', '');
              setFormField('tpaMonthlyInstallmentEst', '');
            }}
            tpaMonths={form?.tpaMonths}
            onTpaMonthsChange={value => setFormField('tpaMonths', value)}
            tpaMonthlyInstallmentEst={form?.tpaMonthlyInstallmentEst}
            onTpaMonthlyInstallmentEstChange={value => setFormField('tpaMonthlyInstallmentEst', value)}
            weatherizationProgramInterest={form?.weatherizationProgramInterest}
            onWeatherizationProgramInterestChange={value => setFormField('weatherizationProgramInterest', value)}
            isSubmitting={isSubmitting}
          />

          {/* Additional Information */}
          <hr />
          <Row>
            <AdditionalInformationField
              value={form?.additionalInformation}
              onChange={value => setFormField('additionalInformation', value)}
              isSubmitting={isSubmitting}
            />
          </Row>
        </>
      )}
    </>
  );
};

export default CaresSection;